import { render, staticRenderFns } from "./setgetlist.vue?vue&type=template&id=64d7f8bf"
import script from "./setgetlist.vue?vue&type=script&lang=js"
export * from "./setgetlist.vue?vue&type=script&lang=js"
import style0 from "./setgetlist.vue?vue&type=style&index=0&id=64d7f8bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports